<!--
  Generated template for the ResultCreatePagerPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->
<ion-header>

  <ion-toolbar>
    <ion-title>{{'RESULT_CREATE_TITLE' | translate}}</ion-title>
    <ion-buttons end>
      <button ion-button color="primary" (click)="save()" *ngIf="displaySaveButton()">
        {{'GLOBAL_SAVE' | translate}}
      </button>
    </ion-buttons>
  </ion-toolbar>

  <ion-toolbar *ngIf="displaySearch()">
    <ion-searchbar type="text" (ionInput)="autocompleteKeyUp($event)" placeholder="{{'RESULT_CREATE_EVENT_NAME' | translate}}" animated="true"></ion-searchbar>
    <ion-buttons end>
      <button ion-button icon-only clear (click)="showNewEvent()">
        <ion-icon name="add"></ion-icon>
      </button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>

<ion-content no-bounce>
  <swiper-container #slider class="swiper-no-swiping">
  <!-- <ion-slides #slider class="swiper-no-swiping"> -->

    <swiper-slide style="padding-top: 96px;">
    <!-- <ion-slide style="padding-top: 96px;"> height: calc(100% - 52px); -->

      <div padding-top *ngIf="!autoCompleteList || autoCompleteList.length === 0 && autoCompleteSelected.length === 0">
        <p text-small>{{'RESULT_CREATE_AUTOCOMPLETE_TIP_1' | translate}} <br /> {{'RESULT_CREATE_AUTOCOMPLETE_TIP_2' |
          translate}}</p>
      </div>

      <div padding-top *ngIf="autoCompleteList && autoCompleteList.length === 0 && !autoCompleteSelected.cid">
        <p text-small>{{'GLOBAL_NO_RESULTS' | translate}}</p>
      </div>

      <div *ngIf="autoCompleteList && autoCompleteList.length === 0 && autoCompleteSelected.cid">
        <p text-left margin-left text-small>
          <ion-icon name="checkmark-circle"></ion-icon> {{'RESULT_CREATE_SELECTED_EVENT' | translate}}
        </p>
        <ion-card>
          <ion-item>
            <h2>{{autoCompleteSelected.eventName}}</h2>
          </ion-item>
          <ion-item>
            <p item-start>
              <ion-icon name="pin"></ion-icon>
            </p>
            <p>{{autoCompleteSelected.zip}} {{autoCompleteSelected.city}}</p>
            <p>{{autoCompleteSelected.area}}, {{autoCompleteSelected.country}}</p>
          </ion-item>
        </ion-card>
      </div>

      <ion-scroll scrollY="true" *ngIf="autoCompleteList && autoCompleteList.length !== 0">
        <ion-list padding-bottom>
          <ion-item *ngFor="let event of autoCompleteList" (click)="autoCompleteSelect(event)">
            <mysport-icon large [cid]="event.cid" item-start></mysport-icon>
            <h2>{{event.eventName}}</h2>
            <p>{{event.country}} {{event.zip}} {{event.city}}</p>
          </ion-item>
        </ion-list>
      </ion-scroll>

      <ion-footer *ngIf="!autoCompleteList || autoCompleteList.length === 0 && autoCompleteSelected.length === 0">
        <ion-grid>
          <ion-row>
            <ion-col col-12>
              <p text-small text-center no-margin>{{'RESULT_CREATE_RESERVIEREN_TIP' | translate}}</p>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col col-12>
              <button ion-button block icon-start color="primary" (click)="showList()">
                {{'RESULT_CREATE_RESERVIEREN_BTN' | translate}}
              </button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-footer>
    </swiper-slide><!-- </ion-slide> -->

    <swiper-slide><!-- <ion-slide> -->
      <ion-list>
        <ion-list-header text-left>
          {{'RESULT_CREATE_LABEL_YEAR' | translate}}
        </ion-list-header>
        <ion-item no-padding>
          <ion-select [(ngModel)]="model.year" *ngIf="!editDate" cancelText="{{'GLOBAL_CANCEL' | translate}}" okText="{{'GLOBAL_OK' | translate}}">
            <ion-option *ngFor="let date of eventDates" [value]="date.value">{{date.value}}</ion-option>
          </ion-select>

          <ion-datetime #timeField displayFormat="DD.MM.YYYY" pickerFormat="DD MM YYYY" [(ngModel)]="editDate" *ngIf="editDate" (ngModelChange)="dateChange($event,timeField)" cancelText="{{'GLOBAL_CANCEL' | translate}}" doneText="{{'GLOBAL_DONE' | translate}}">
          </ion-datetime>

          <button ion-button clear icon-only item-end no-margin (click)="changeDateEditable()">
            <ion-icon *ngIf="!editDate" name="add"></ion-icon>
            <ion-icon *ngIf="editDate" name="checkmark"></ion-icon>
          </button>
        </ion-item>
      </ion-list>

      <ion-list>
        <ion-list-header text-left>
          {{'RESULT_CREATE_LABEL_DISTANCE' | translate}}
        </ion-list-header>
        <ion-item no-padding>
          <ion-select [(ngModel)]="model.dist" *ngIf="!distPart1" cancelText="{{'GLOBAL_CANCEL' | translate}}" okText="{{'GLOBAL_OK' | translate}}">
            <ion-option *ngFor="let distance of eventDistances" [value]="distance.value">{{distance.value}}</ion-option>
          </ion-select>
          <ion-input margin-horizontal type="number" [(ngModel)]="distPart1.data" *ngIf="distPart1"></ion-input>
          <ion-input margin-horizontal type="number" [(ngModel)]="distPart2.data" *ngIf="distPart2"></ion-input>
          <ion-input margin-horizontal type="number" [(ngModel)]="distPart3.data" *ngIf="distPart3"></ion-input>
          <button ion-button clear icon-only item-end no-margin (click)="changeDistaceEditable()">
            <ion-icon *ngIf="!distPart1" name="add"></ion-icon>
            <ion-icon *ngIf="distPart1" name="checkmark"></ion-icon>
          </button>
        </ion-item>
      </ion-list>

      <ion-list>
        <ion-list-header text-left>
          {{'RESULT_CREATE_LABEL_TYPE' | translate}}
        </ion-list-header>
        <ion-item no-padding>
          <ion-select [(ngModel)]="model.type" *ngIf="!selectedGrading" cancelText="{{'GLOBAL_CANCEL' | translate}}" okText="{{'GLOBAL_OK' | translate}}">
            <ion-option *ngFor="let type of eventTypes" [value]="type.value">{{type.value}}</ion-option>
          </ion-select>
          <ion-select [(ngModel)]="selectedGrading" *ngIf="selectedGrading" cancelText="{{'GLOBAL_CANCEL' | translate}}" okText="{{'GLOBAL_OK' | translate}}">
            <ion-option *ngFor="let type of eventGrading" [value]="type.value">{{type.value}}</ion-option>
          </ion-select>
          <button ion-button clear icon-only item-end no-margin (click)="changeGradingEditable()">
            <ion-icon *ngIf="!selectedGrading" name="add"></ion-icon>
            <ion-icon *ngIf="selectedGrading" name="checkmark"></ion-icon>
          </button>
        </ion-item>
        <ion-item no-padding *ngIf="selectedVintageFrom">
          <ion-select [(ngModel)]="selectedVintageFrom" cancelText="{{'GLOBAL_CANCEL' | translate}}" okText="{{'GLOBAL_OK' | translate}}">
            <ion-option *ngFor="let type of eventVintagesFrom" [value]="type.value">{{type.value}}</ion-option>
          </ion-select>
        </ion-item>
        <ion-item no-padding *ngIf="selectedVintageTo">
          <ion-select [(ngModel)]="selectedVintageTo" *ngIf="selectedVintageTo" cancelText="{{'GLOBAL_CANCEL' | translate}}" okText="{{'GLOBAL_OK' | translate}}">
            <ion-option *ngFor="let type of eventVintagesTo" [value]="type.value">{{type.value}}</ion-option>
          </ion-select>
        </ion-item>
      </ion-list>
    </swiper-slide><!-- </ion-slide> -->

    <swiper-slide><!-- <ion-slide> -->
      <ion-list>
        <ion-list-header text-left>
          {{'RESULT_CREATE_LABEL_DETAILS' | translate}}
        </ion-list-header>
        <ion-item>
          <ion-icon name="stopwatch" item-start showWhen="android"></ion-icon>
          <ion-label>{{'RESULT_CREATE_LABEL_TIME' | translate}}</ion-label>
          <ion-datetime displayFormat="HH:mm:ss" [(ngModel)]="model.time">
          </ion-datetime>
        </ion-item>
        <ion-item>
          <ion-icon name="flag" item-start showWhen="android"></ion-icon>
          <ion-label>{{'RESULT_CREATE_LABEL_PLACE' | translate}}</ion-label>
          <ion-input type="number" [(ngModel)]="model.place" text-right>
          </ion-input>
        </ion-item>
      </ion-list>

      <ion-list>
        <ion-list-header text-left>
          {{'RESULT_CREATE_LABEL_PHOTOS' | translate}}
        </ion-list-header>
        <button #uploadButton ion-item (click)="selectPhoto()">
          <ion-icon name="image" item-start showWhen="android"></ion-icon>
          {{'RESULT_CREATE_BUTTON_UPLOAD' | translate}}
        </button>
      </ion-list>

      <img *ngIf="model.img" [src]="model.img" />
    </swiper-slide><!-- </ion-slide> -->

    <swiper-slide><!-- <ion-slide> -->
      <ion-list>
        <ion-item>
          <ion-icon name="calendar" color="primary" item-start></ion-icon>
          <p>{{autoCompleteSelected.eventName}}</p>
        </ion-item>
        <ion-item>
          <ion-icon name="pin" color="primary" item-start></ion-icon>
          <p>{{autoCompleteSelected.zip}} {{autoCompleteSelected.city}}</p>
          <p>{{autoCompleteSelected.area}}, {{autoCompleteSelected.country}}</p>
        </ion-item>
      </ion-list>

      <ion-list>
        <ion-item>
          {{'RESULT_CREATE_LABEL_YEAR' | translate}}
          <ion-note item-end>
            {{model.year}}
          </ion-note>
        </ion-item>
        <ion-item>
          {{'RESULT_CREATE_LABEL_DISTANCE' | translate}}
          <ion-note item-end>
            {{model.dist}}
          </ion-note>
        </ion-item>
        <ion-item>
          {{'RESULT_CREATE_LABEL_TYPE' | translate}}
          <ion-note item-end>
            {{model.type}}
          </ion-note>
        </ion-item>
      </ion-list>

      <ion-list>
        <ion-item>
          {{'RESULT_CREATE_LABEL_TIME' | translate}}
          <ion-note item-end>
            {{model.time}}
          </ion-note>
        </ion-item>
        <ion-item>
          {{'RESULT_CREATE_LABEL_PLACE' | translate}}
          <ion-note item-end>
            {{model.place}}
          </ion-note>
        </ion-item>
      </ion-list>

      <img *ngIf="model.img" [src]="model.img" />
    </swiper-slide><!-- </ion-slide> -->
  </swiper-container><!-- </ion-slides> -->
  <ion-fab right bottom *ngIf="displayNextButton()">
    <button ion-fab (click)="next()">
      <ion-icon name="arrow-forward"></ion-icon>
    </button>
  </ion-fab>
  <ion-fab left bottom *ngIf="this.slider.swiper.activeIndex>0">
    <button ion-fab (click)="prev()">
      <ion-icon name="arrow-back"></ion-icon>
    </button>
  </ion-fab>
</ion-content>